import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query RequestType($id: Int!) {
  requestType(id: $id) {
    id
    name
    description
    defaultType
    active
    system
    keywords {
      token
    }
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

export function parseRequestType(item) {
  return {
    id: item.id,
    title: item.name,
    desc: item.description,
    defaultType: item.defaultType,
    active: item.active,
    system: item.system,
    removable: item.removable,
    keywords: item.keywords ? item.keywords.map((word) => word.token) : [],
    teams: item.teams,
    allTeamsOn: item.allTeamsOn,
  };
}

export function parseRequestType4Up(item) {
  return {
    name: item.title,
    description: item.desc,
    defaultType: item.defaultType,
    active: item.active,
    keywords: item.keywords,
    system: item.system,
    teamsIds: item.teamsIds,
    allTeamsOn: item.allTeamsOn,
  };
}

function getRequestType(id) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: { id: parseInt(id, 10) },
  }).then((res) => parseRequestType(res.data.requestType));
}

export default getRequestType;
